import { $prose } from "@milkdown/utils"
import { Plugin, PluginKey } from "@milkdown/prose/state"

// Converts inline markdown patterns (**bold**, *italic*, `code`, ~~strike~~) to formatting
// Handles case where user types delimiters first, then inserts text between them
const patterns = [
	{ regex: /\*\*(.+?)\*\*/, mark: "strong", delim: 2 },
	{ regex: /(?<!\*)\*([^*]+?)\*(?!\*)/, mark: "em", delim: 1 },
	{ regex: /`([^`]+?)`/, mark: "inlineCode", delim: 1 },
	{ regex: /~~(.+?)~~/, mark: "strike", delim: 2 },
]

function hasMarkInRange(doc, from, to, markType) {
	let found = false
	doc.nodesBetween(from, to, (n) => {
		if (n.isText && markType.isInSet(n.marks)) found = true
	})
	return found
}

function findAndConvert(state, tr) {
	const { doc, schema, selection } = state
	let modified = false
	doc.descendants((node, pos) => {
		if (!node.isText || !node.text) return

		for (const { regex, mark, delim } of patterns) {
			const markType = schema.marks[mark]
			if (!markType) continue

			const match = new RegExp(regex.source, "g").exec(node.text)
			if (!match || !match[1]) continue

			const start = pos + match.index
			const end = start + match[0].length
			if (hasMarkInRange(doc, start, end, markType)) continue
			// A pattern the cursor sits inside is one still being written.
			if (selection.from > start && selection.to < end) continue

			// Delete delimiters (end first to preserve positions), then apply mark
			tr.delete(end - delim, end)
			tr.delete(start, start + delim)
			tr.addMark(start, start + match[1].length, markType.create())
			modified = true
			return false // Stop after first conversion to avoid position issues
		}
	})
	return modified
}

export const inlineMarkdownPlugin = $prose(() => new Plugin({
	key: new PluginKey("inline-markdown"),
	// Moving the cursor counts: it is how a pattern the user was typing inside
	// becomes one they have finished.
	appendTransaction(transactions, _, newState) {
		if (!transactions.some((tr) => tr.docChanged || tr.selectionSet)) return null
		const tr = newState.tr
		return findAndConvert(newState, tr) ? tr : null
	},
}))
